
import { useState } from 'react';
import { useToast } from "@/hooks/use-toast";
import { Button } from "./ui/button";

const Navbar = () => {
  const { toast } = useToast();

  const handleSalesRedirect = () => {
    window.location.href = 'https://agera.solutions/';
  };

  const handleSolutionsRedirect = () => {
    window.location.href = 'https://ragnarai.netlify.app/';
  };

  return (
    <nav className="fixed w-full z-50 bg-gradient-to-br from-[#1A1F2C]/95 via-[#6E59A5]/95 to-[#9b87f5]/95 backdrop-blur-md">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="flex items-center justify-between py-4">
          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-3">
              <img 
                src="/lovable-uploads/4d149f3d-3fe0-43d1-8d16-f1b18b35ef5f.png" 
                alt="Lionsales Solutions Logo" 
                className="w-12 h-12 md:w-14 md:h-14 filter brightness-150 hover:brightness-200 transition-all duration-300"
              />
              <span className="text-2xl font-display text-white/90 hidden md:block">
                Lionsales Solutions
              </span>
            </div>
          </div>
          <div className="hidden md:flex space-x-8 items-center">
            <Button 
              onClick={handleSolutionsRedirect}
              className="text-lg font-display bg-gradient-to-r from-purple-500/80 to-indigo-500/80 hover:from-purple-500 hover:to-indigo-500 text-white border-none shadow-lg hover:shadow-xl transition-all duration-300"
            >
              Solutions
            </Button>
            <Button 
              onClick={handleSalesRedirect}
              className="text-lg font-display bg-gradient-to-r from-purple-500/80 to-indigo-500/80 hover:from-purple-500 hover:to-indigo-500 text-white border-none shadow-lg hover:shadow-xl transition-all duration-300"
            >
              Sales
            </Button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
